var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/CommonVideoPlayer/CommonVideoPlayer.jinja"] = require( "front/components/CommonVideoPlayer/CommonVideoPlayer.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonStory/CommonStoryVideo.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonStory/CommonStoryVideo.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/CommonVideoPlayer/CommonVideoPlayer.jinja", false, "assets/app/front/components/CommonStory/CommonStoryVideo.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "CommonVideoPlayer")) {
var t_7 = t_4.CommonVideoPlayer;
} else {
cb(new Error("cannot import 'CommonVideoPlayer'")); return;
}
context.setVariable("CommonVideoPlayer", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"CommonStoryBlock CommonStoryVideo\" data-provider=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"provider"), env.opts.autoescape);
t_9 += "\">\n        <figure class=\"CommonStoryVideo-video CommonStoryVideo-video--";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"wide")) {
t_9 += "wide";
;
}
else {
t_9 += "normal";
;
}
t_9 += "\">\n            <div class=\"CommonStoryVideo-videoWrapper\">\n                <div class=\"CommonStoryVideo-videoPlaceholder\">\n                    ";
t_9 += runtime.suppressValue((lineno = 9, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonVideoPlayer"), "CommonVideoPlayer", context, [runtime.makeKeywordArgs({"data": {"provider": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"provider"),"cover": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img"),"code": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"embed")}})])), env.opts.autoescape);
t_9 += "\n                </div>\n            </div>\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"caption")) {
t_9 += "\n                <div class=\"CommonStoryVideo-videoCaptionWrapper\">\n                    <figcaption class=\"CommonStoryVideo-videoCaption\">";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"caption")), env.opts.autoescape);
t_9 += "</figcaption>\n                </div>\n            ";
;
}
t_9 += "\n        </figure>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("CommonStoryVideo");
context.setVariable("CommonStoryVideo", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonStory/CommonStoryVideo.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryVideo.jinja
// module id = 95
// module chunks = 0